import { Flex, Stack, Text } from "@chakra-ui/core";
import React from "react";
import { Link } from "react-router-dom";

export const FooterNav = (props) => {
  return (
    <Flex direction="column" mx={["4", "4", "0"]} my={["4", "4", "0"]}>
      <Text
        fontWeight="800"
        color="#fff"
        mb="4"
        fontSize={["16px", "16px"]}
        fontFamily="Familiar Pro"
      >
        {props.title}
      </Text>
      <Stack>
        {props.links.map((link, index) => {
          return (
            <Link to={link.path} key={index}>
              <Text
                mb="2"
                fontSize={["14px", "16px"]}
                display="inline-block"
                className="hvr-underline-from-left"
              >
                {link.title}
              </Text>
            </Link>
          );
        })}
      </Stack>
    </Flex>
  );
};
